import { ChatbotType, ResponseType } from '@/types';
import { API_BOT_CHATBOT } from '../urls';
import { get } from './chatbotAxios';

const url = API_BOT_CHATBOT;

const getBots = (): Promise<ResponseType<ChatbotType[]>> => get(`${url}`);

export { getBots };
